import type React from 'react';
import { useTranslation } from 'react-i18next';
import { PageNotice } from '@/components/pageNotice';

/**
 * `/analytics/reporting` — the shell's second tab.
 *
 * Empty on purpose, for the reasons in `FinancialPositionPage`: the route and
 * the tab exist now so the bar's shape is settled, and the data hook and
 * `ErrorBoundary` arrive with the first read this tab actually makes.
 */
export const ReportingPage: React.FC = () => {
    const { t } = useTranslation('pages');

    return (
        <PageNotice
            body={t('analytics.reporting.emptyBody')}
            icon="solar:document-text-bold-duotone"
            testId="reporting-empty"
            title={t('analytics.reporting.emptyTitle')}
            tone="info"
        />
    );
};
